export default __webpack_public_path__ + "static/media/BaniereDesktop.5fd3eeb3.svg";